export const CUSTOM_FIELD_MAX_LENGTH: number = 50
export const CUSTOM_FIELD_CONTENTS_TOTAL_LENGTH: number = 3000
